// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2PQLM","label":"LabeledBox_label__1W3P3"};